module.exports = __webpack_public_path__ + "04efd27555f3b4faf0d96998eb2d37c7.xml";